<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <h4>保障項目設定</h4>
        <div class="mb-4 font-20">
          <a
            class="btn btn-default float-right fw-600"
            @click="$router.push({ name: 'CoverageItemQuery' })"
            >保障項目對應商品查詢
          </a>
          <a
            class="btn btn-default float-right fw-600"
            @click="openCoverageKindAddModalOpen"
            >新增保障項目歸類
          </a>
          <a
            class="btn btn-default float-right fw-600"
            @click="openCoverageItemAddModal"
            >新增保障項目設定
          </a>
        </div>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" @click="$router.push({ name: 'CoverageItemNameList' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="familyRelationNavLink"
              :class="{ active: $route.name === 'CoverageItemNameList' }"
              >保障項目名稱列表</a
              >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'CoverageItemKindList' })">
            <a
              class="nav-link"
              role="tab"
              data-toggle="tab"
              id="policyInfoNavLink"
              :class="{ active: $route.name === 'CoverageItemKindList' }"
              >保障項目歸類列表</a
              >
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <router-view
          :reload="reload"
          ></router-view>
      </div>
    </div>
    <!--新增保障項目設定-->
    <Coverage-Item-Add-Modal
      :open="coverageItemAddModalOpen"
      :coverageCategoryOption="coverageCategoryOption"
      :isEdit="false"
      @cancel="panelClose('coverageItemAddModalOpen')"
      @close="closeCoverageItemAddModal"
      />
    <!--新增保障項目歸類-->
    <Coverage-Kind-Add-Modal
      :open="coverageKindAddModalOpen"
      :isEdit="false"
      @cancel="panelClose('coverageKindAddModalOpen')"
      @close="closeCoverageKindAddModal"
      />
  </main>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import CoverageItemAddModal from "./components/CoverageItemAddModal";
import CoverageKindAddModal from "./components/CoverageKindAddModal";
import { queryCoverageCategoryMain } from "@/service";

export default {
  name: "CoverageItem",
  mixins: [commonMixin],
  components: {
    CoverageItemAddModal,
    CoverageKindAddModal,
  },
  data() {
    return {
      coverageCategoryOption: [],
      coverageItemAddModalOpen: false,
      coverageKindAddModalOpen: false,
      reload: false,
    };
  },
  methods: {
    async openCoverageItemAddModal() {
      const res = await queryCoverageCategoryMain(
        this.$store.state.userInfo.id
      );
      this.coverageCategoryOption = res.data;
      this.panelOpen("coverageItemAddModalOpen");
      this.reload = false;
    },
    openCoverageKindAddModalOpen() {
      this.panelOpen("coverageKindAddModalOpen");
      this.reload = false;
    },
    closeCoverageItemAddModal() {
      this.panelClose("coverageItemAddModalOpen");
      this.reload = true;
    },
    closeCoverageKindAddModal() {
      this.panelClose("coverageKindAddModalOpen");
      this.reload = true;
    },
  },
  mounted() {
    this.$router.push({ name: "CoverageItemNameList" });
  },
};
</script>

<style scoped>
.container-fluid {
  padding-left: 40px;
  padding-right: 40px;
}
.font-20 {
  font-size: 20px;
}
</style>
